import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Dropdown, Panel, PrimaryButton, Stack, TextField} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import validateForm from "../../Utilities/validateForm";

function AddTask(props) {
    const [user] = useContext(AuthContext);
    const [description, setDescription] = useState('');
    const [venture, setVenture] = useState(null);
    const [project, setProject] = useState(null);
    const [type, setType] = useState(null);
    const [types, setTypes] = useState([]);
    const [projects, setProjects] = useState([]);
    const [formErrors, setFormErrors] = useState([])

    const _submit = (e) => {
        e.preventDefault();
        const data = {description: description, venture_id: venture ? venture.key : null, project_id: project ? project.key : null, type_id: type ? type.key : null};
        if (validateForm(data, ['description', 'venture_id', 'type_id'], setFormErrors)) {
            fetch(`/api/task`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(json => {
                    props.onSuccess(json);
                    props.dismissPanel();
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddCost'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setDescription('');
        const abortController = new AbortController();
        async function fetchList() {
            await fetch(`/api/project`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setProjects(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }
        async function fetchTypes() {
            await fetch(`/api/task/type`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setTypes(data.map((item) => ({key: item.id, text: item.type})));
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchTypes();
        fetchList();
        return () => abortController.abort();
    }, [props.add, user.token])

    let ventures = projects.map((item) => ({key: item.venture_id, text: item.venture}));
    ventures = [...new Map(ventures.map((item) => [item["key"], item])).values()];
    const [filteredProjects, setFilteredProjects] = useState([]);
    useEffect(() => {
        const none = {key: null, text: 'Brak'}
        const newProjects = projects
            .filter(item => item.venture_id === venture.key)
            .map(item => ({
                key: item.id,
                text: item.project
            }));
        setFilteredProjects([none, ...newProjects]);
    }, [venture]);
    useEffect(() => {
        setProject(null);
    }, [filteredProjects])
    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Zadanie"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddCost'>
                <Dropdown
                    label="Typ"
                    selectedKey={type ? type.key : undefined}
                    onChange={(e, item) => setType(item)}
                    placeholder="Wybierz z listy"
                    options={types}
                    errorMessage={formErrors['type_id']}
                    required
                />
                <TextField required multiline autoFocus label='Opis' value={description}
                           onChange={(e) => setDescription(e.target.value || '')}/>
                <Dropdown
                    label="Kontrakt"
                    selectedKey={venture ? venture.key : undefined}
                    onChange={(e, item) => setVenture(item)}
                    placeholder="Wybierz z listy"
                    options={ventures}
                    errorMessage={formErrors['venture_id']}
                    required
                />
                <Dropdown
                    label="Projekt"
                    selectedKey={project ? project.key : undefined}
                    onChange={(e, item) => setProject(item)}
                    placeholder="Wybierz z listy"
                    options={filteredProjects}
                    disabled={venture === null}
                />
            </form>
        </Panel>
    )
}

export default AddTask;